

export default function mobileMenu() {

    const burger = document.querySelector('.js-burger');
    const mobileMenu = document.querySelector('.js-mobile-menu');
    var distance = 0;

    const mobileMainMenu = document.querySelector('.js-header-mobile-main-menu');
    const mobileMenuSubLinks = document.querySelectorAll('.js-mobile-menu-sub-link');
    const mobileMenuBack = document.querySelector('.js-header-mobile-back');

    function disable_scroll() {
        document.querySelector("body").classList.add("dis-scroll");
        document.querySelector("body").scrollTo({
          top: distance,
          left: 0,
        });
    }

    function enable_scroll() {

        document.querySelector("body").classList.remove("dis-scroll");

        if ( distance != 0 ) {
            window.scrollTo({
                top: distance,
                left: 0,
            });
        }

    }


    if ( burger && mobileMenu ) {
        burger.addEventListener('click',function(){
            burger.classList.toggle('open');

            mobileMenu.classList.toggle("open");


            if ( burger.classList.contains("open") ){
                distance = window.pageYOffset;
                disable_scroll();
            } else {
                enable_scroll();
            }

        });
    }


    if ( mobileMenuSubLinks.length ) {
        for (let link of mobileMenuSubLinks ) {
            link.addEventListener('click',function(e){
                e.preventDefault();

                let dataMenu = link.dataset.menu;
                let dataMenuTitle = link.innerHTML;
                console.log('', dataMenuTitle);
                let subMenu = document.querySelector(`.js-header-mobile-sub-list[data-menu=${dataMenu}]`);

                document.querySelector(`.js-header-mobile-sub-list.active`)?.classList.remove('active');
                document.querySelector('.js-header-mobile-main-menu.active')?.classList.remove('active');
                document.querySelector('.js-header-mobile-sub-menu')?.classList.add('active');
                
                subMenu?.classList.add('active');
                subMenu.querySelector('.js-mobile-menu-sub-title').innerHTML = dataMenuTitle;

            });
        }
    }

    if ( mobileMenuBack ) {
        mobileMenuBack.addEventListener('click',function(){
            document.querySelector('.js-header-mobile-sub-list.active')?.classList.remove('active');
            document.querySelector('.js-header-mobile-sub-menu.active')?.classList.remove('active');
            document.querySelector('.js-header-mobile-main-menu')?.classList.add('active');
        });
    }

/* 
    if ( mobileMenuSubLink ) {
        mobileMenuSubLink.addEventListener('click',function(e){
            e.preventDefault();

            document.querySelector('.header-mobile__box.active').classList.remove('active');
            document.querySelector('.js-header-mobile-sub-menu').classList.add('active');

        });
    }

    
     */


}